import React from 'react';
import ActionBar from '../../general/actionbar/ActionBar';
import { FiMaximize, FiMinimize } from 'react-icons/fi';
import { useI18n } from '../../../../i18n';
import { className, fromProps } from '../../../lib/className';

/**
 * @param {Object} props
 * @param {function} props.onClick
 * @param {string} [props.title]
 * @param {boolean} [props.expanded]
 * @param {boolean} [props.disabled]
 */

function ActionExpand(props) {
	const { f } = useI18n();

	return (
		<ActionBar.Action
			className={className('expand', fromProps(props))}
			onClick={props.onClick}
			disabled={props.disabled}
			title={props.title || props.expanded ? f('collapse') : f('expand')}
		>
			{props.expanded ? <FiMinimize /> : <FiMaximize />}
		</ActionBar.Action>
	);
}

export default ActionExpand